'use strict';

(function(z, _) {

    /**
     * Tariff association grid
     */
    z.TariffVendorGrid = z.GridView.extend({

        /**
         * Bounding element
         */
        el: "#tariffVendor-page",

        /**
         * Events
         *
         * @return {undefined}
         */
        events: function() {
            return _.extend({}, z.FiltersView.prototype.events,{
                "click #add-tariffVendor-modal-btn": "onAddEntry",
                "click .tariffVendor-edit-button": "onEditEntry",
                "click .tariffVendor-delete-button": "onDeleteEntry",
                "change #tariffVendor-service-field" : 'onChangeServiceFilter',
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {
            z.GridView.prototype.initialize.apply(this, arguments);

            this.vendorId = this._getVendorId();

            this.initializeEvents();
        },

        onChangeServiceFilter: function(){
            $('#tariffVendor-service-field').addClass(' chosen-select ');
            var serviceId = $("#tariffVendor-service-field").val();
            var $holder = $("#tariffVendor-service-params-container");
            $holder.empty();

            if (!serviceId) {
                return;
            }
            var url =  '/tariff-vendor/create/filter/service/{service}';
            url = url.replace('{service}', serviceId);
            var opts = {
                method      : 'GET',
                dataType    : 'html',
                contentType : 'text/plain'
            };

            z.request.make(url, null, function(jqXhr, status){

                if (status !== 'success') {
                    return;
                }

                $holder.append(jqXhr.responseText);
            }.bind(this), opts);
        },

        /**
         * Initialize the events.
         *
         * @return {undefined}
         */
        initializeEvents: function() {

            this.$("#tariffVendor-service-field").chosen({
                search_contains: true
            });
        },

        /**
         * Get datatable id.
         *
         * @return {string} - datatable id
         */
        getDatatableId: function() {
            return 'page-tariffVendor-datatable';
        },

        /**
         * Get page path.
         *
         * @return {string} - page path
         */
        getPath: function() {

            return '/tariff-vendor/' + this.vendorId;
        },

        /**
         * Get success message container id.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message container id
         */
        getSuccessMessageContainerId: function() {
            return 'tariffVendor-success-message';
        },


        /**
         * Get success message text.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message text variable
         */
        getSuccessMessageText: function() {
            return Translator.trans('js.success_message_tariffVendor_form');
        },

        /**
         * Get success event name
         *
         * @return {string} - success event name
         */
        getSuccessEventName: function() {
            return 'tariffVendor.success';
        },

        /**
         * Retrieves the vendor id if it is available
         * @returns {number|null} The vendor id
         * @private
         */
        _getVendorId: function(){

            var regex = /^\/tariff-vendor\/(\d+)(.*)$/g;

            var result = regex.exec(window.location.pathname);

            if (!result) {

                return null;
            }

            return result[1];
        },

        /**
         * Method that opens a confirm box when an entry is deleted
         *
         * @param {Event} event click event
         * @return {undefined}
         */
        onDeleteEntry: function(event) {

            event.preventDefault();

            this.entryId = $(event.currentTarget).attr('data-id');

            // Implementing sweet alert confirmation
            swal({
                title: Translator.trans('js.tariff_vendor_delete_confirm_window_title'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#18a689',
                cancelButtonColor: 'rgb(113, 125, 145)',
                confirmButtonText: Translator.trans('js.tariff_vendor_delete_confirm_btn')
            }).then(function () {
                this._deleteEntry(this.entryId);
            }.bind(this)).catch(swal.noop);
        },

        /**
         * Delete the entry
         *
         * @param {int} id - entry id
         * @return {undefined}
         * @private
         */
        _deleteEntry: function(id) {

            var entryModel = new z.TariffVendorModel({ id: id });

            // Delete the model
            entryModel.destroy({

                // On success
                success: function() {

                    // On success, apply the filters
                    this.applyFilters();

                }.bind(this),

                // on error
                error: function() {

                    // todo

                }.bind(this)
            });
        }
    });

})(window.z = window.z || {}, _);
